// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UCDhPk28I7gO32nK1OFd {
  text-align: center;
}

.PQL1z1R_rFIjrh0jt5HM {
  font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./src/components/EmailVerify/components/EmailError/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".contentDescription {\n  text-align: center;\n}\n\n.contentTitle {\n  font-weight: 900;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentDescription": `UCDhPk28I7gO32nK1OFd`,
	"contentTitle": `PQL1z1R_rFIjrh0jt5HM`
};
export default ___CSS_LOADER_EXPORT___;
